module.exports = __webpack_public_path__ + "img/开心点点消.f4dcf161.png";